import * as React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Flex } from '@lightspeed/flame/Core';

import {
  StyledConfirmClose,
  StyledConfirmCloseContent,
} from 'root/apps/InventoryCountScanQueue/views/ScanQueue.style';

interface ConfirmCloseProps {
  canBeSafelyClosed: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmClose: React.FC<ConfirmCloseProps> = ({
  canBeSafelyClosed,
  onConfirm,
  onCancel,
}) => {
  const handlePromptCancel = () => {
    onCancel();
  };
  const handlePromptConfirm = () => {
    onConfirm();
  };
  return (
    <StyledConfirmClose data-test="confirm-close-view">
      <StyledConfirmCloseContent p={6}>
        {!canBeSafelyClosed ? (
          <>
            <h3>Are you sure you want to leave?</h3>
            <p>
              Wait for the items in pending scans to upload completely. If you navigate away, you
              will lose all of your items in pending scans.
            </p>
          </>
        ) : (
          <>
            <h3>Upload complete.</h3>
            <p>All pending scans were successfully uploaded.</p>
          </>
        )}
        <Flex justifyContent="center" alignItems="center">
          <Button onClick={handlePromptCancel} data-test="confirm-close-cancel-btn">
            Stay
          </Button>
          <Button
            onClick={handlePromptConfirm}
            data-test="confirm-close-confirm-btn"
            variant={!canBeSafelyClosed ? 'danger' : 'secondary'}
            fill={true}
            ml={2}
          >
            Leave
          </Button>
        </Flex>
      </StyledConfirmCloseContent>
    </StyledConfirmClose>
  );
};
